module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/medical-questions/medical-questions.component.css
// module id = ./src/app/shared/components/medical-questions/medical-questions.component.css
// module chunks = main